<template>
  <span class="d-flex align-items-start">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div class="col-7 col-lg-12 mail-status-cell__content">
      <MailStatusChipComponent v-if="hasStatus" :mailStatus="mailStatus" @open="$emit('open', mailStatus)" />
      <MailStatusEmptyComponent v-else />
    </div>
  </span>
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";
import MailStatusChipComponent from "@/components/mailStatus/MailStatusChipComponent.vue";
import MailStatusEmptyComponent from "@/components/mailStatus/MailStatusEmptyComponent.vue";

export default {
  name: "SortTableMailStatusCellComponent",
  components: { MailStatusChipComponent, MailStatusEmptyComponent, SortTableMobileFirstColumnComponent },
  props: {
    column: {
      type: Object,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    mailStatus: {
      type: Object,
      default: null,
    },
  },
  emits: ["open"],
  computed: {
    hasStatus() {
      return (this.mailStatus?.status ?? null) !== null;
    },
  },
};
</script>

<style lang="scss" scoped>
.mail-status-cell {
  // Le libellé de statut est long pour une colonne étroite : il se replie sur les limites de mots
  // plutôt que de déborder, sans couper les mots au milieu.
  &__content {
    min-width: 0;
    overflow-wrap: anywhere;
  }
}
</style>
